import _toConsumableArray from "/Users/lhtan/Projects/damu/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import * as t from '@babel/types';
import { transform as transformElement, injectTransformer } from './trasnformers';
import { isEmptyJSXText } from '../utils';
import { getIdentifierName } from '../utils/get-identifier-name';
import { setAttribute } from './attributes';
import { documentCreateElement } from '../api/document/create-element';
import { documentCreateTextNode } from '../api/document/create-text-node';
import { appendChild } from '../api/append-child';
import Flags, { turnOnFlag } from '../flags';
injectTransformer('JSXElement', transformJSXElement);
injectTransformer('JSXText', transformJSXText);
injectTransformer('StringLiteral', transformJSXText);
export function transformJSXElement(path, parent) {
  var name = getIdentifierName(path.node.openingElement.name);
  var identifier = path.scope.generateUidIdentifier(name);

  if (/^[A-Z]/.test(name)) {
    turnOnFlag(path, Flags.APPEND_COMPONENT); // component

    var statements = [t.expressionStatement(t.assignmentExpression('=', identifier, t.newExpression(t.identifier(name), [])))];
    return {
      identifier: identifier,
      statements: statements
    };
  } else {// dom
  }

  var result = [];
  var declaration = documentCreateElement(identifier, name);
  result.push(declaration);
  var attributes = path.node.openingElement.attributes.map(function (attr) {
    return setAttribute(identifier, attr.name.name, attr.value, path);
  });
  attributes.forEach(function (attr) {
    return result.push(attr);
  });
  var childrens = path.get('children').filter(isEmptyJSXText).map(function (elem) {
    return transformElement(elem, identifier);
  }).map(function (_ref) {
    var statements = _ref.statements;
    return statements;
  });
  childrens.forEach(function (children) {
    return result.push.apply(result, _toConsumableArray(children));
  });

  if (parent) {
    result.push(appendChild(parent, identifier, path));
  }

  return {
    identifier: identifier,
    statements: result
  };
}
export function transformJSXText(path, parent) {
  var identifier = path.scope.generateUidIdentifier('text');
  var statements = [documentCreateTextNode(identifier, t.stringLiteral(path.node.value))];

  if (parent) {
    statements.push(appendChild(parent, identifier, path));
  }

  return {
    identifier: identifier,
    statements: statements
  };
}